module.exports = __webpack_public_path__ + "static/media/bg-404.bbf5c059.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/bg-404.png
// module id = 276
// module chunks = 6